/**
 * Platform availability probe.
 *
 * Uses **light** endpoints only (`/api/platform/live` on CEX, `/api/live` on DEX) —
 * no Redis/LTDashboard on the CEX health route. See `control-plane` `health.py`.
 *
 * Cross-origin: sibling SPA fetches the other host (CORS on both backends).
 */

import { cexApi } from './apiBase.js'
import { dexApi } from './apiBase.js'

/** Must exceed worst-case dev `load` on heavy `/api/platform/health` if that URL were used; liveness is fast. */
export const HEALTH_PROBE_TIMEOUT_MS = 5000

/** Consecutive failed probes before UI shows "offline" (avoids one-off flaps). */
const CONSECUTIVE_FAILS_FOR_OFFLINE = 2

export async function probeHealthUrl(url, { timeoutMs = HEALTH_PROBE_TIMEOUT_MS } = {}) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const res = await fetch(url, {
      signal: controller.signal,
      cache: 'no-store',
      credentials: 'omit',
    })
    return res.ok
  } catch {
    return false
  } finally {
    clearTimeout(timer)
  }
}

export async function pingDex() {
  return probeHealthUrl(dexApi('/api/live'))
}

export async function pingCex() {
  return probeHealthUrl(cexApi('/api/platform/live'))
}

export async function pingBoth() {
  const [dex, cex] = await Promise.all([pingDex(), pingCex()])
  return { dex, cex }
}

export { CONSECUTIVE_FAILS_FOR_OFFLINE as HEALTH_CONSECUTIVE_FAILS_FOR_OFFLINE }
